var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center ma-2"},[_c('v-snackbar',{attrs:{"value":_vm.snackbar,"color":_vm.color},on:{"input":_vm.onClose}},[_vm._v(" "+_vm._s(_vm.text)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }